

























  import { Component, Vue, Watch } from 'vue-property-decorator'
  import CompanyInfo from './compontents/CompanyInfo.vue'
  import MainHeader from '@/components/MainHeader'
  import SupervisionMenu from '@/components/SupervisionMenu'
  @Component({
      components:{
          CompanyInfo,
          MainHeader,
          SupervisionMenu
      }
  })
  export default class Login  extends Vue {
    private routerArr:any=[]
    created(){
        this.getRouter()
    }
    getRouter(){
        this.routerArr=[]
        this.$route.matched.filter((ele: any) => {
            if(ele.meta&&ele.meta.title!=undefined){
                this.routerArr.push(ele.meta.title)
            }
        })
    }
    @Watch('$route')
        onChangeData(val:any) {
        this.getRouter()
    }
    private backTo() {
      this.$router.push({path: '/msgenterprise'})
    }
  }
